import { Check, Circle, CalendarClock, ArrowRight } from "lucide-react";

const STATUS_TONE = {
  approved: "bg-teal-light text-teal",
  not_approved: "bg-red-50 text-red-600",
  developmental: "bg-amber-50 text-amber-700",
};

export const PhaseACard = ({ phase }) => {
  if (!phase) return null;
  const tone = STATUS_TONE[phase.status] || "bg-linen text-ink-600";

  return (
    <section className="rounded-3xl bg-white border border-linen-border shadow-soft p-6 sm:p-8" data-testid="phase-a-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] text-teal font-bold">Becoming a partner</p>
          <h2 className="mt-1.5 font-heading font-medium text-2xl sm:text-3xl text-navy">
            Three steps, then you're in.
          </h2>
        </div>
        <span
          data-testid="phase-a-status"
          className={`inline-flex items-center rounded-full px-3.5 py-1.5 text-xs font-bold ${tone}`}
        >
          {phase.status_label}
        </span>
      </div>

      <ol className="mt-7 space-y-3" data-testid="phase-a-steps">
        {phase.steps.map((s, i) => (
          <li
            key={s.key}
            data-testid={`phase-a-step-${s.key}`}
            className={`flex items-start gap-4 rounded-2xl border p-4 sm:p-5 ${
              s.done ? "border-teal/40 bg-teal-light/20" : "border-linen-border bg-linen/40"
            }`}
          >
            <span
              className={`shrink-0 mt-0.5 w-7 h-7 rounded-full flex items-center justify-center border ${
                s.done ? "bg-teal border-teal text-white" : "border-ink-300 text-ink-300"
              }`}
            >
              {s.done ? <Check size={15} strokeWidth={3} /> : <Circle size={8} fill="currentColor" />}
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2.5">
                <span className="text-[11px] uppercase tracking-widest text-teal font-bold">Step {i + 1}</span>
              </div>
              <h3 className={`mt-1 font-heading font-medium text-lg ${s.done ? "text-ink-400" : "text-navy"}`}>
                {s.label}
              </h3>
              <p className="mt-1.5 text-[14px] text-ink-600 leading-relaxed">{s.why}</p>
            </div>
          </li>
        ))}
      </ol>

      {phase.meeting_url && !phase.approved && (
        <div className="mt-6 rounded-2xl bg-navy p-5 sm:p-6 text-white" data-testid="phase-a-meeting">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-lime font-bold">
            <CalendarClock size={13} /> Optional while you wait
          </div>
          <h3 className="mt-1.5 font-heading font-medium text-xl">Sit in on the Partner Overview call.</h3>
          <p className="mt-2 text-sm text-white/70 leading-relaxed max-w-lg">
            A short walkthrough of how the program actually runs. No pitch, and it has no bearing on
            your application either way — plenty of partners skip it entirely.
          </p>
          <a
            href={phase.meeting_url}
            target="_blank"
            rel="noreferrer"
            data-testid="phase-a-meeting-link"
            className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-lime text-navy-deep font-semibold text-sm px-5 py-2.5 hover:brightness-105 transition-all"
          >
            Grab a seat <ArrowRight size={14} />
          </a>
        </div>
      )}
    </section>
  );
};

export default PhaseACard;
